export default "__VITE_ASSET__Bidxirx7__"